import React, { useState, useRef } from "react";
import { FormWrapper } from "./FormWrapper";
import { AddAndCloseButton } from "../generic/AddAndCloseButton";
import { AddAndContinueButton } from "../generic/AddAndContinueButton";
import { CloseButton } from "../generic/CloseButton";

export const AddFavorite = ({ onClose, addFavorite, favorites }) => {
  const [name, setName] = useState("");
  const nameRef = useRef(null);

  const favoriteAlreadyExists = favorites.some(
    (favorite) => favorite.name === name
  );

  return (
    <FormWrapper>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <h3 style={{ margin: "0 auto" }}>Neuer Favorit</h3>
          <input
            ref={nameRef}
            type="text"
            id="name"
            value={name}
            inputMode="text"
            enterKeyHint="done"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                addFavorite({ name });
                onClose();
              }
            }}
            onChange={(e) => setName(e.target.value)}
            style={{ fontSize: "1.5rem" }}
            autoFocus
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "2rem",
          }}
        >
          <AddAndCloseButton
            disabled={!name || favoriteAlreadyExists}
            onClick={() => {
              addFavorite({ name });
              onClose();
            }}
          />

          <AddAndContinueButton
            disabled={!name || favoriteAlreadyExists}
            onClick={() => {
              addFavorite({ name });
              setName("");
              nameRef.current?.focus();
            }}
          />

          <CloseButton onClick={onClose} />
        </div>
      </div>
    </FormWrapper>
  );
};
